import { CRM } from "@/components/atomic-crm/root/CRM";
import {
  authProvider,
  dataProvider,
} from "@/components/atomic-crm/providers/php";

/**
 * Application entry point: the CRM on the PHP + SQLite backend in `api/`.
 *
 * The API base URL is `/api` by default (Vite proxies it to
 * http://127.0.0.1:8081 in development, and in production `api/` sits next to
 * the built frontend); override it with `VITE_API_URL`.
 *
 * The demo variant with the in-browser fake backend lives in `demo/App.tsx`.
 */
const App = () => (
  <CRM
    dataProvider={dataProvider}
    authProvider={authProvider}
    disableTelemetry
  />
);

export default App;
